
<span class="loader" 
[style.--scale-loader]=" width / 48"
[style.--ratio]="- ((4 * thickness)-12) + 'px'"
[style.--loaderThickness]=" thickness + 'px'"
[style.--primaryColor]="primaryColor"
[style.--secondaryColor]="secondaryColor"></span>